module.exports = __webpack_public_path__ + "static/media/Logo.ea495dea.png";